declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export type EscaEvent =
  | 'hero_cta_click'
  | 'header_cta_click'
  | 'expertise_cta_click'
  | 'case_open'
  | 'price_cta_click'
  | 'form_start'
  | 'form_submit'
  | 'phone_click'
  | 'email_click'
  | 'scroll_depth'

export function track(
  event: EscaEvent,
  payload: Record<string, unknown> = {},
): void {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event,
    ...payload,
  })
}

const DEPTHS = [25, 50, 75, 90] as const

export function initScrollDepthTracking(): () => void {
  if (typeof window === 'undefined') return () => {}
  const fired = new Set<number>()

  const onScroll = () => {
    const doc = document.documentElement
    const scrollable = doc.scrollHeight - window.innerHeight
    if (scrollable <= 0) return
    const pct = (window.scrollY / scrollable) * 100
    for (const depth of DEPTHS) {
      if (pct >= depth && !fired.has(depth)) {
        fired.add(depth)
        track('scroll_depth', { depth })
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  return () => window.removeEventListener('scroll', onScroll)
}
